import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import Home from './components/Home';
import About from './components/About';
import Contact from './components/Contact';
import './styles/index.css'
import { initializeApp } from "firebase/app";

// Your web app's Firebase configuration
const firebaseConfig = {
    apiKey: process.env.REACT_APP_API_KEY,
    authDomain: process.env.REACT_APP_AUTH_DOMAIN,
    projectId: process.env.REACT_APP_PROJECT_ID,
    storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
    appId: process.env.REACT_APP_APP_ID,
    measurementId: process.env.REACT_APP_MEASUREMENT_ID
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
//const analytics = getAnalytics(app);

function App() {
    return (
        <Router>
            {/*<nav className="bg-gray-800 p-4">*/}
            {/*    <div className="container mx-auto">*/}
            {/*        <ul className="flex space-x-4">*/}
            {/*            <li>*/}
            {/*                <Link to="/" className="text-white">Home</Link>*/}
            {/*            </li>*/}
            {/*            <li>*/}
            {/*                <Link to="/about" className="text-white">About</Link>*/}
            {/*            </li>*/}
            {/*            <li>*/}
            {/*                <Link to="/contact" className="text-white">Contact</Link>*/}
            {/*            </li>*/}
            {/*        </ul>*/}
            {/*    </div>*/}
            {/*</nav>*/}

            <Routes>
                <Route path="/" element={<Home/>}/>
                <Route path="/about" element={<About/>}/>
                <Route path="/contact" element={<Contact/>}/>
            </Routes>

        </Router>
    );
}

export default App;